import { render, staticRenderFns } from "./loyalty-points-viewer.vue?vue&type=template&id=e9787644&scoped=true"
import script from "./loyalty-points-viewer.vue?vue&type=script&lang=js"
export * from "./loyalty-points-viewer.vue?vue&type=script&lang=js"
import style0 from "./loyalty-points-viewer.vue?vue&type=style&index=0&id=e9787644&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9787644",
  null
  
)

export default component.exports